import axios from 'axios';
import { apiUrl } from './index';

export default {
  getItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/billing`,
      params,
    });
  },
  createItem(comment) {
    return axios({
      method: 'post',
      url: `${apiUrl}/billing`,
      data: {
        ...comment,
      },
    });
  },
  updateItem(item) {
    return axios({
      method: 'put',
      url: `${apiUrl}/billing/${item.id}`,
      data: {
        ...item,
      },
    });
  },
  getItem({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/billing/${id}`,
    });
  },
  removeItem({ id }) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/billing/${id}`,
    });
  },
  getInvoiceEmails({ page = 1, perPage = -1, id }) {
    const params = {
      page,
    };

    if (perPage > -1) {
      params.per_page = perPage;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/billing/${id}/emails`,
      params,
    });
  },
  updateInvoiceEmails({ id, invoice_emails }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/billing/${id}/emails`,
      data: {
        invoice_emails,
      }
    });
  },
  uploadCSV({ csv }) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const fd = new FormData();

    fd.append('csv', csv.file);
    return axios.post(`${apiUrl}/billing/upload`, fd, config);
  },
  vatCheck({ country, id }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/vat/${country}/${id}`,
    });
  },
};
